import React from "react";
import DatePicker from "react-datepicker";
import Moment from "moment";
import Popper from '@material-ui/core/Popper';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { connect } from "react-redux";
import MaskedInput from "react-text-mask";

import { showToast } from "Source/globalFunction";

@connect(store => {
    return {
        files: store.files
    }
})

class DateModified extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            anchorEl: null,
            date: "from"
        }
    }

    render() {
        const { dispatch, files } = this.props;
        const open = Boolean(this.state.anchorEl);

        const isFromGreaterThanTo = (date) => {
             return this.state.date === "from" && files.filters.options.uploadedDate.to.value && Moment(Moment(files.filters.options.uploadedDate.to.value).format("YYYY/MM/DD")).isBefore(Moment(date).format("YYYY/MM/DD"));
        }

        const isToGreaterThanFrom = (date) => {
             return this.state.date === "to" && files.filters.options.uploadedDate.from.value && Moment(Moment(files.filters.options.uploadedDate.from.value).format("YYYY/MM/DD")).isAfter(Moment(date).format("YYYY/MM/DD"));
        }

        const handleChange = date => {
            if(isToGreaterThanFrom(date)) {
                showToast("error", "Period to must be after the Period from date.");
            } else if(isFromGreaterThanTo(date)) {
                showToast("error", "Period from must be after the Period to date.");
            } else {
                dispatch({type: "UPDATE_FILES_FILTERS", filters: this.state.date === "from" ? {
                    uploadedDate: {
                        ...files.filters.options.uploadedDate,
                        from: {value: date ? Moment(date).format("YYYY-MM-DD") : null, label: date ? Moment(date).format("MM/DD/YYYY") : null}
                    }
                } : {
                    uploadedDate: {
                        ...files.filters.options.uploadedDate,
                        to: {value: date ? Moment(date).format("YYYY-MM-DD") : null, label: date ? Moment(date).format("MM/DD/YYYY") : null}
                    }
                }});
                
                handleClose();
            }
        }

        const handleClick = (event, type) => {
            this.setState({
                ...this.state, 
                anchorEl: event.currentTarget,
                date: type
            });
        }
        
        const handleClose = () => {
            this.setState({...this.state, anchorEl: null});
        }

        const handleInputChange = e => {
            if(moment(e.target.value).isValid() && e.target.value.length >= 10) {
                if(isToGreaterThanFrom(e.target.value)) {
                    showToast("error", "Period to must be after the Period from date.");
                } else if(isFromGreaterThanTo(e.target.value)) {
                    showToast("error", "Period from must be after the Period to date.");
                } else {
                    handleChange(e.target.value);
                }
            } 
        }

        const handleInputBlur = e => {
            if(e) {
                if(!moment(e.target.value).isValid() || e.target.value == 0 || e.target.value.length < 10 || isToGreaterThanFrom(e.target.value) || isFromGreaterThanTo(e.target.value)) {
                    handleChange(null);
                }
            }
        }

        const handleInputFocus = (type) => {
            this.setState({
                ...this.state, 
                date: type
            });
        }

        return (
            <div class="optionRow">
                <span>Date Modified</span>
                <div class="optionChoices">
                    <div class="formRow">
                        <div class="formContainer">
                            <span>from</span>
                            <div class="inputContainer">
                                <MaskedInput 
                                    guide={false} 
                                    mask={[/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]} 
                                    placeholder="MM/DD/YYYY" 
                                    type="text"
                                    class="form-control" 
                                    value={files.filters.options.uploadedDate.from.label} 
                                    onChange={handleInputChange} 
                                    onBlur={handleInputBlur} 
                                    onFocus={() => handleInputFocus("from")} 
                                />
                                <i onClick={e => handleClick(e, "from")} class={`material-icons`}>calendar_today</i>  
                            </div>
                        </div>
                        <div class="formContainer">
                            <span>to</span>
                            <div class="inputContainer">
                                <MaskedInput 
                                    guide={false} 
                                    mask={[/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]} 
                                    placeholder="MM/DD/YYYY" 
                                    type="text" 
                                    class="form-control" 
                                    value={files.filters.options.uploadedDate.to.label} 
                                    onChange={handleInputChange} 
                                    onBlur={handleInputBlur} 
                                    onFocus={() => handleInputFocus("to")} 
                                />
                                <i onClick={e => handleClick(e, "to")} class={`material-icons`}>calendar_today</i>
                            </div>
                        </div>
                    </div>
                    <Popper
                        id={`uploadedDate_${this.state.date}`}
                        open={open}
                        anchorEl={this.state.anchorEl}
                        placement="bottom-start"
                        style={{zIndex: 101}}
                    >
                        <ClickAwayListener onClickAway={handleClose}>
                            <div class="uploadDatePicker">
                                <DatePicker 
                                    inline
                                    useWeekdaysShort={true}
                                    shouldCloseOnSelect={false}
                                    selected={this.state.date === "from" ? (files.filters.options.uploadedDate.from.value ? Moment(files.filters.options.uploadedDate.from.value).toDate() : undefined) : (files.filters.options.uploadedDate.to.value ? Moment(files.filters.options.uploadedDate.to.value) : undefined)}
                                    onChange={handleChange}
                                    minDate={files.filters.options.uploadedDate.from.value && this.state.date === "to" ? Moment(files.filters.options.uploadedDate.from.value).toDate() : null}
                                />
                            </div>
                        </ClickAwayListener>
                    </Popper>
                </div>
            </div>
        );
    }
}

export default DateModified;